import UserGroupContainer from "./UserGroupContainer";

export default UserGroupContainer;
